<template>
	<div>
		<el-form :inline="true" >
			<!-- <el-form-item label="按个人">
				<el-input
						v-model="searchForm.name"
						placeholder="人员号或姓名"
						clearable
				>
				</el-input>

				
			</el-form-item> -->

			<el-form-item>
				<el-input
						v-model="searchForm.code"
						placeholder="人员编号"
						clearable
						style="display: block; width: 180px;"
				>
				</el-input>
			</el-form-item>
			<el-form-item>
				<el-input
						v-model="searchForm.name"
						placeholder="姓名"
						clearable
						style="display: block; width: 180px;"
				>
				</el-input>
			</el-form-item>

			<el-form-item label-width="100px">
				<el-date-picker 
					v-model="queryDate" 
					type="daterange" 
					value-format="yyyy-MM-dd"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期">
				</el-date-picker>
			</el-form-item>

			<el-form-item>
				<el-button @click="getRecordList">搜索</el-button>
			</el-form-item>
		</el-form>

		<el-table
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%;margin-top: -10px;"
				:height="tableHeight"
				:row-style="{height: '0px'}"
				:cell-style="{padding: '8px'}"
				:header-cell-style="{background: '#E6F2FE', height:'6px',padding:'6px'}"
				border
				stripe
				@selection-change="handleSelectionChange">

			<el-table-column
					prop="personNo"
					label="人员号"
					sortable
					width="120"
					show-overflow-tooltip>
			</el-table-column>

			<el-table-column
					prop="personName"
					label="姓名"
					sortable
					width="100"
					show-overflow-tooltip>
			</el-table-column>

			<el-table-column
					prop="recordTime"
					label="通行时间"
					sortable
					width="180"
					show-overflow-tooltip>
			</el-table-column>

			<el-table-column
					prop="recordType"
					label="通行方式"
					sortable
					width="120">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.recordType === '01' " type="success">刷卡</el-tag>
					<el-tag size="small" v-else-if="scope.row.recordType === '02' " type="success">密码</el-tag>
					<el-tag size="small" v-else-if="scope.row.recordType === '03' " type="success">远程</el-tag>
					<el-tag size="small" v-else-if="scope.row.recordType === '04' " type="success">指纹</el-tag>
					<el-tag size="small" v-else-if="scope.row.recordType === '05' " type="success">钥匙</el-tag>
					<el-tag size="small" v-else-if="scope.row.recordType === '06' " type="success">扫码</el-tag>
				</template>
			</el-table-column>

			<el-table-column
					prop="locationFullName"
					label="地理位置"
					sortable
					width="300"
					show-overflow-tooltip>
			</el-table-column>

			<el-table-column
					prop="machineNum"
					label="设备编号"
					sortable
					width="150"
					show-overflow-tooltip>
			</el-table-column>

			<el-table-column
					prop="doorNo"
					label="门号"
					sortable
					width="100"
					show-overflow-tooltip>
			</el-table-column>

			<el-table-column
					prop="accessFlag"
					label="进/出"
					sortable
					width="100">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.accessFlag === 0 " type="danger">出</el-tag>
					<el-tag size="small" v-else-if="scope.row.accessFlag === 1 " type="success">进</el-tag>
				</template>
			</el-table-column>

			<el-table-column
					prop="resultFlag"
					label="通行结果"
					sortable
					width="120">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.resultFlag === 0 " type="danger">失败</el-tag>
					<el-tag size="small" v-else-if="scope.row.resultFlag === 1 " type="success">成功</el-tag>
				</template>
			</el-table-column>

			<el-table-column
					prop="identityName"
					label="身份"
					sortable
					width="100"
					show-overflow-tooltip>
			</el-table-column>

			<el-table-column
					prop="fullName"
					sortable
					label="部门"
					show-overflow-tooltip>
			</el-table-column>

		</el-table>


		<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				layout="total, sizes, prev, pager, next, jumper"
				:page-sizes="[10, 20, 50, 100, 500, 1000]"
				:current-page="current"
				:page-size="size"
				:total="total">
		</el-pagination>


		<!--新增对话框-->
		<el-dialog
				title="高级查询"
				:visible.sync="dialogVisible"
				width="600px"
				:before-close="handleClose"
				:close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">

				<el-form-item label="身份名称" prop="identityName" label-width="100px">
					<el-input v-model="editForm.identityName" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="有效期类型" prop="validType" label-width="100px">
					<el-radio-group v-model="editForm.validType">
						<el-radio :label=0>按固定日期</el-radio>
						<el-radio :label=1>按日算</el-radio>
						<el-radio :label=2>按月算</el-radio>
						<el-radio :label=3>按年算</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="固定有效日期" prop="validDate" label-width="100px">
					<el-date-picker v-model="editForm.validDate" type="date" placeholder="选择日期"></el-date-picker>
				</el-form-item>

				<el-form-item label="有效期数" prop="validNum" label-width="100px">
					<el-input-number v-model="editForm.validNum" autocomplete="off" :min="0" :max="65535"></el-input-number>
				</el-form-item>

				<el-form-item label="描述" prop="remark" label-width="100px">
					<el-input v-model="editForm.remark" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="submitForm('editForm')">确定</el-button>
					<el-button @click="resetForm('editForm')">重置</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>

	</div>
</template>

<script>
	export default {
		name: "Record",
		data() {
			return {
				searchForm: {},
				delBtlStatu: true,

				total: 0,
				size: 10,
				current: 1,

				dialogVisible: false,
				editForm: {

				},

				tableData: [],

				editFormRules: {
					identityName: [
						{required: true, message: '请输入身份名称', trigger: 'blur'}
					],
					validType: [
						{required: true, message: '请选择有效期类型', trigger: 'blur'}
					]
				},

				multipleSelection: [],

				permDialogVisible: false,
				permForm: {},
				defaultProps: {
					children: 'children',
					label: 'identityName'
				},
				permTreeData: [],
				queryDate: ''
			}
		},
		computed: {
			tableHeight: function() {
				return screen.height > 900 ? 650: 550
			}
		},
		created() {
			this.defaultDate();
			this.getRecordList();
			// this.getRecordList()

			// this.$axios.get('/pin/record/list').then(res => {
			// 	this.permTreeData = res.data.data
			// })
		},
		methods: {
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				console.log("勾选")
				console.log(val)
				this.multipleSelection = val;

				this.delBtlStatu = val.length == 0
			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.size = val
				this.getRecordList()
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.current = val
				this.getRecordList()
			},

			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false
				this.editForm = {}
			},
			handleClose() {
				this.resetForm('editForm')
			},

			getRecordList() {
				this.$axios.get("/pin/record/list", {
					params: {
						name: '',
						beginDate: this.queryDate[0],
						endDate: this.queryDate[1],
						current: this.current,
						size: this.size
					}
				}).then(res => {
					this.tableData = res.data.data.records
					this.size = res.data.data.size
					this.current = res.data.data.current
					this.total = res.data.data.total
				})
			},

			submitForm(formName) {
				this.getRecordList()
			},
			defaultDate(){
				//获取当前时间
				let date = new Date()
				//获取当前时间的年份转为字符串
				let year = date.getFullYear().toString() 
				//获取月份，由于月份从0开始，此处要加1，判断是否小于10，如果是在字符串前面拼接'0'
				let month = date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1).toString():(date.getMonth()+1).toString() 
				//获取天，判断是否小于10，如果是在字符串前面拼接'0'
				let da = date.getDate() < 10 ? '0'+date.getDate().toString():date.getDate().toString() 
				//字符串拼接，开始时间，结束时间
				let nowDate = year + '-' + month + '-' + da
				//将值设置给插件绑定的数据
				this.queryDate = [nowDate, nowDate] 
				console.log("queryDate111", this.queryDate)
			},
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}
</style>